import { Directive, ElementRef, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { distinctUntilChanged } from 'rxjs';
import { CookieConsentService } from '../services/cookie-consent.service';

@Directive({ selector: '[data-analytics]', standalone: false })
export class AnalyticsAttributeGateDirective {
  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly cookieConsentService = inject(CookieConsentService);
  private readonly destroyRef = inject(DestroyRef);

  private readonly originalValue: string | null;

  constructor() {
    const host = this.el.nativeElement;
    this.originalValue = host.getAttribute('data-analytics');

    this.toggleAnalyticsAttribute(this.cookieConsentService.analyticsAllowed());

    toObservable(this.cookieConsentService.analyticsAllowed)
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((allowed) => this.toggleAnalyticsAttribute(allowed));
  }

  private toggleAnalyticsAttribute(allowed: boolean): void {
    const host = this.el.nativeElement;

    if (allowed) {
      if (this.originalValue) {
        host.setAttribute('data-analytics', this.originalValue);
      }
    } else {
      host.removeAttribute('data-analytics');
    }
  }
}
